import img1 from '../assets/images/banner.jpg'

export const bannerData = [
    {
        id:1,
        image:img1,
        subheading:'100% genuine Products',
        heading:'Tasty & healthy orgamic food',
        button: 'explore products'
    },
    {
        id:2,
        image:img1,
        subheading:'100% genuine Products',
        heading:'Tasty & healthy orgamic food',
        button: 'explore products'
    },
    {
        id:3,
        image:img1,
        subheading:'100% genuine Products',
        heading:'Tasty & healthy orgamic food',
        button: 'explore products'
    },
]